<template>
    <vx-box color="white" class="p-6 flex flex-col h-full">
        <div class="flex items-center gap-3">
            <a
                v-if="props.integration.url"
                :href="props.integration.url"
                target="_blank"
                rel="noopener noreferrer"
                class="size-9 flex items-center justify-center shrink-0 rounded shadow hover:shadow-md transition-shadow"
                :class="props.integration.logo ? 'bg-slate-50' : 'bg-sky-400'"
            >
                <component
                    :is="props.integration.logo"
                    v-if="props.integration.logo"
                    class="size-7 max-h-full max-w-full"
                />
                <span v-else class="text-white text-base font-semibold">{{
                    props.integration.name.charAt(0).toUpperCase()
                }}</span>
            </a>
            <template v-else>
                <div
                    v-if="props.integration.logo"
                    class="size-9 flex items-center justify-center shrink-0 bg-slate-50 rounded shadow"
                >
                    <component :is="props.integration.logo" class="size-7 max-h-full max-w-full" />
                </div>
                <div
                    v-else
                    class="size-9 shrink-0 bg-sky-400 rounded shadow flex items-center justify-center text-white text-base font-semibold"
                >
                    {{ props.integration.name.charAt(0).toUpperCase() }}
                </div>
            </template>
            <h3 class="grow text-base font-extrabold text-slate-800 leading-4">{{ props.integration.name }}</h3>
            <vx-badge v-if="props.isEnabled" color="success" size="sm">Enabled</vx-badge>
        </div>
        <div class="mt-3 grow text-sm font-normal text-slate-400">{{ props.integration.tagline }}</div>
        <vx-button class="mt-6" color="muted-light" :href="`/settings/relay/${props.integration.slug}`">
            View details
            <font-awesome-icon widthAuto class="ml-1" :icon="faArrowRightLong" />
        </vx-button>
    </vx-box>
</template>

<script setup lang="ts">
import { VxBadge, VxBox, VxButton } from '@voxie/frontend-components';
import type { Integration } from './integrations';
import { faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps<{
    integration: Integration;
    isEnabled: boolean;
}>();
</script>
